import Spinner from '@xo-union/tk-component-spinner';
import React from 'react';

import CardContainer from '../CardContainer';
import RsvpGuidanceCard from './RsvpGuidanceCard';
import RsvpPageCard from './RsvpPageCard';
import { useSeeWorkflow, useWorkflowUnstartedState } from './utils';

interface Props {
  seeRsvpGuidance: boolean;
}

const PageCard: React.FC<Props> = ({ seeRsvpGuidance }) => {
  const seeWorkflow = useSeeWorkflow();
  const { loading, isUnstartedState } = useWorkflowUnstartedState();

  if (loading) {
    return (
      <CardContainer>
        <Spinner />
      </CardContainer>
    );
  }
  if (seeWorkflow && isUnstartedState && seeRsvpGuidance) {
    return <RsvpGuidanceCard />;
  }
  return <RsvpPageCard />;
};

export default PageCard;
